// This function parses a CSS string and returns an object containing
// CSS properties as keys and their corresponding values as values.

export function parseCustomStyles(customStyles: string) {
  // Split the input CSS string into an array of individual CSS rules
  // using the semicolon ';' as the delimiter. If the input is empty
  // or undefined, an empty array is created.
  const styles = customStyles ? customStyles?.split?.(';') : [];

  // Initialize an empty object to store the parsed CSS properties and values.
  const styleObject = {};

  // Iterate through each individual CSS rule in the 'styles' array.
  for (const style of styles) {
    // Split each CSS rule into its property and value components
    // using the colon ':' as the delimiter.
    const [property, value] = style?.split?.(':');

    // Check if both a property and a value exist for the current CSS rule.
    if (property && value) {
      // Trim any leading or trailing whitespace from the property and value
      // and add them as key-value pairs to the 'styleObject' object.
      styleObject[property.trim()] = value?.trim();
    }
  }

  // Return the final 'styleObject' containing the parsed CSS properties and values.
  return styleObject;
}
